import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { VisitorResponse } from '../visitor-sign-ins';
import { AcceptTrainingRequest } from './accept-training-request';
import { VisitorDetails } from './visitor-details-response';
import { VisitorSignInStatusResponse } from './visitor-sign-in-status.response';
import { VisitorTrainingResposne } from './visitor-training-response';
import { VisitorUpdateRequest } from './visitor-update-request';

const path = 'visitors';

@Injectable({
  providedIn: 'root',
})
export class VisitorsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  getVisitors() {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);

    return this.httpClient.get<VisitorResponse[]>(url);
  }

  get(visitorId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${visitorId}`);

    return this.httpClient.get<VisitorDetails>(url);
  }

  getVisitorTraining(visitorId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${visitorId}/training`
    );

    return this.httpClient.get<VisitorTrainingResposne[]>(url);
  }

  getTraining() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/training`);

    return this.httpClient.get<VisitorTrainingResposne[]>(url);
  }

  getSignInStatus(visitorId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${visitorId}/status`
    );

    return this.httpClient.get<VisitorSignInStatusResponse>(url);
  }

  acceptTraining(request: AcceptTrainingRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/training/accept`);

    return this.httpClient.post(url, request);
  }

  updateVisitor(visitorId: string, visitorRequest: VisitorUpdateRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${visitorId}`);

    return this.httpClient.put(url, visitorRequest);
  }
}
